module.exports = __webpack_public_path__ + "img/idcard2.16f16f0a.png";